export const PHONE_MASK = ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
export const PHONE_MASK_EIGHT = ['8', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
export const DAY_MASK = [/\d/, /\d/];
export const YEAR_MASK = [/\d/, /\d/, /\d/, /\d/];
